import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import POS from './components/POS';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/pos" element={<PrivateRoute><POS /></PrivateRoute>} />
            <Route path="/" element={<Navigate to="/login" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();

  console.log('PrivateRoute check:', { user: !!user, loading, localStorageToken: !!localStorage.getItem('auth_token'), localStorageUsername: !!localStorage.getItem('username') });

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  // Check both context state and localStorage for authentication
  const isAuthenticated = user || (localStorage.getItem('auth_token') && localStorage.getItem('username'));

  console.log('Authentication result:', isAuthenticated);

  return isAuthenticated ? children : <Navigate to="/login" replace />;
}

export default App;